export default function getDependenceComponentKey(dependencies: any[], key: string) {
  const dependence = dependencies.find(({ type }) => type === key)
  if (!dependence) {
    throw '请添加所需依赖到组件的initValue.dependencies'
  }
  return `magic-ui-${dependence.type}-${dependence.component_id}-${dependence.version}`
}